import React from "react";

const WebPages_Intro = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Intro</h1>
      <p>This is the WebPages Intro page content.</p>
    </div>
  );
};

export default WebPages_Intro;
